import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';
import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import { MeasurementDetailChart } from "../common/MeasurementDetailChart";
import moment from "moment";
import Chip from '@material-ui/core/Chip';
import RouterIcon from '@material-ui/icons/Router';
import ReloadIcon from '@material-ui/icons/Replay';
import { CsvBuilder } from 'filefy';

import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});


const defaults = {
    id: true,
    device: false,
    created: false,
    ml: false,
    ms: false,
    numPoints: false,
    cAmbient: false,
    rh: false,
    battery: false,
    network: false,
    rssi: false,
    test: false,
    pageSize: 20,
};

const defaultsPropertyName = 'p71.measurements.defaults';

class Measurements extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    handleGraphDialogClose = () => {
        this.setState({ graphDialog: false })
    }

    mapField(column) {
        switch (column) {
            case "device":
                return "uuid"
            default:
                return column;
        }
    }

    exportCsv = async (columns, data) => {

        try {

            this.setState({
                exporting: true,
                progressValue: 0
            });

            const allMeasurements = [];
            let totalCount = 0;
            const first = 100;
            let offset = 0

            this.showMessage("Export wird angestoßen. Bitte verlassen Sie die Seite nicht, solange der Exportvorgang läuft.", "info");

            do {
                
                const filters = []
                for (const column of columns) {
                    if (column.tableData.filterValue !== undefined && column.tableData.filterValue !== null) {
                        filters.push({
                            column: column,
                            field: column.field,
                            type: column.type,
                            comparator: column.comparator,
                            value: column.tableData.filterValue
                        })
                    }
                }

                const find = helper.whereString(filters, this.mapField, ["uuid", "device"]);

                const result = await graphql.clientWithToken(this.props.accessToken).query({
                    query: gql`
                    query {
                        measurements(first: 100, offset: ${offset}, where: ${find}, orderBy: [{column: "id" direction: ASC}]) {
                            totalCount
                            elements {
                                ... on Measurement {
                                    id
                                    device {uuid}
                                    created {X}
                                    ml
                                    ms
                                    numPoints
                                    cAmbient
                                    rh
                                }
                            }
                        }
                    }
                `,
                    fetchPolicy: "no-cache"
                });

                totalCount = result.data.measurements.totalCount;
                offset = offset + first;
                for (const element of result.data.measurements.elements) {
                    allMeasurements.push(
                        {
                            device: element.device,
                            created: element.created ? moment(element.created.X, 'X').format('DD.MM.YYYY, HH:mm') : null,
                            ml: element.ml,
                            ms: element.ms,
                            numPoints: element.numPoints,
                            cAmbient: element.cAmbient,
                            rh: element.rh,
                        }
                    )
                }

                if (totalCount !== 0) {
                    this.setState({
                        exporting: true,
                        progressValue: (allMeasurements.length / totalCount) * 100
                    });
                }
            } while (allMeasurements.length < totalCount);

            const builder = new CsvBuilder('Messungen.csv')

                .setColumns(["Gerät","Gespült am", "Menge in ml" , "Dauer in ms", "Anzahl Messpunkte", "Umgebungstemperatur", "relative Luftfeuchte"])
                .addRows(allMeasurements.map(measurement => { return [measurement.device.uuid,measurement.created,measurement.ml,measurement.ms,measurement.numPoints,measurement.cAmbient,measurement.rh] }))
                .exportFile();

            this.setState({
                exporting: false,
                progressValue: 0
            });
        } catch (error) {
            this.setState({
                exporting: false,
                progressValue: 0
            });
            this.showMessage(error.message, "error");
        }

    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("measurements.device"),
                            field: 'device',
                            hidden: this.default("device"),
                            cellStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            headerStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                return rowData && rowData.device ? <Chip label={rowData.device.uuid} icon={<RouterIcon />} /> : null
                            }
                        },
                        {
                            title: i18n.get("measurements.created"),
                            field: 'created',
                            hidden: this.default("created"),
                            type: "datetime",
                            cellStyle: {
                                width: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                width: '400px',
                                maxWidth: '400px',
                            },
                            filterComponent: helper.DateRangeFilter,
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("measurements.ml"),
                            field: 'ml',
                            hidden: this.default("ml"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("measurements.ms"),
                            field: 'ms',
                            hidden: this.default("ms"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("measurements.points"),
                            field: 'numPoints',
                            hidden: this.default("numPoints"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                return rowData ? rowData.numPoints : 0
                            }
                        },
                        {
                            title: i18n.get("measurements.cAmbient"),
                            field: 'cAmbient',
                            hidden: this.default("cAmbient"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("measurements.rh"),
                            field: 'rh',
                            hidden: this.default("rh"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            render: rowData => {
                                if (rowData) {
                                    return rowData.rh ? `${rowData.rh} %` : '';
                                } else {
                                    return ''
                                }
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("measurements.battery"),
                            field: 'battery',
                            hidden: this.default("battery"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                if (rowData) {
                                    // return helper.batteryIconOf(rowData.battery)
                                    return `${rowData.battery} %`
                                } else {
                                    return null;
                                }
                            }
                        },
                        {
                            title: i18n.get("measurements.network"),
                            field: 'network',
                            comparator: 'IS',
                            hidden: this.default("network"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("measurements.rssi"),
                            field: 'rssi',
                            hidden: this.default("rssi"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                if (rowData) {
                                    // return helper.signalBarIconOf(rowData.rssi);
                                    return `${rowData.rssi} dB`;
                                } else {
                                    return null
                                }
                            }
                        },
                        {
                            title: i18n.get("measurements.signal"),
                            field: 'signal',
                            hidden: this.default("signal"),
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            type: "numeric",
                            filterComponent: helper.RangeFilter,
                            sorting: true,
                            filtering: true,
                            render: rowData => {
                                return rowData && rowData.signal ? `${rowData.signal} %` : '-'
                            }
                        },
                        {
                            title: i18n.get("measurements.test"),
                            field: 'test',
                            hidden: this.default("test"),
                            cellStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            headerStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            type: "boolean",
                            sorting: true,
                            filtering: false
                        },
                        {
                            title: i18n.get("measurements.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: true,
                            filtering: false
                        },
                    ]}
                    detailPanel={rowData => {
                        return <MeasurementDetailChart data={rowData.points ? rowData.points : []} />
                    }}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {


                                let where = helper.whereString(query["filters"], this.mapField, ["uuid"]);
                                const orderBy = helper.orderByString(query, this.mapField, "created", query["orderBy"] && query["orderBy"]["field"] === "device")

                                if (query["orderBy"] && query["orderBy"]["field"] === "device" && where === "[]") {
                                    where = '[{column: "created", comparator: GT, datetime: -1}]'
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        measurements(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Measurement {
                                                    id,
                                                    device {uuid}
                                                    created {X}
                                                    ml
                                                    ms
                                                    numPoints
                                                    points { c ml mm }
                                                    cAmbient
                                                    battery
                                                    network
                                                    rssi
                                                    signal
                                                    test
                                                    rh
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                const searchResult = {
                                    page: query.page,
                                    data: result.data.measurements.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                device: element.device,
                                                created: element.created ? moment(element.created.X, 'X').toDate() : null,
                                                ml: element.ml,
                                                ms: element.ms,
                                                numPoints: element.numPoints,
                                                points: element.points,
                                                cAmbient: element.cAmbient,
                                                battery: element.battery,
                                                network: element.network,
                                                rssi: element.rssi,
                                                signal: element.signal,
                                                test: element.test,
                                                rh: element.rh,
                                            };
                                        }),
                                    totalCount: result.data.measurements.totalCount
                                }

                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    actions={[{
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }]}
                    title={i18n.get("measurements.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: true,
                        exportCsv: this.exportCsv,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize"),
                        pageSizeOptions: [5, 20, 50]
                    }}
                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />

            </div>
        )
    }
}

Measurements.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(Measurements))